module.exports = __webpack_public_path__ + "static/media/sosgrandine_logo.af178727.jpg";